export default "__VITE_ASSET__fe2fc538__"